import { router, usePage } from "@inertiajs/react"
import { LogOut } from "lucide-react"
import { Button } from "@/components/ui/button"
import type { SharedProps } from "@/types"

export function ImpersonationBanner() {
  const { current_user, is_impersonating } = usePage<SharedProps>().props

  if (!is_impersonating || !current_user) return null

  return (
    <div className="bg-amber-500 text-white px-4 py-2 flex items-center justify-center gap-3 text-sm font-medium">
      <span>Connecté en tant que {current_user.full_name}</span>
      <Button variant="secondary" size="sm" className="h-7 text-xs" onClick={() => router.delete("/impersonation")}>
        <LogOut className="mr-1.5 size-3" />
        Revenir à mon compte
      </Button>
    </div>
  )
}
